import type { TypeModalButtonConfig } from '../types';

// ----------------------------------------------------------------------------

function hideCurrentModal(elTarget: HTMLElement | null): void {
    const elModal = elTarget?.closest('.modal');

    if (elModal instanceof HTMLElement) {
        elModal.hideModal();
    }
}

function buildClickHandler(item: TypeModalButtonConfig): ((evt: Event) => void | Promise<void>) | undefined {
    if (item.fnAction === false) {
        return undefined;
    }

    if (typeof item.fnAction === 'function') {
        const fnAction = item.fnAction;

        return async function (this: HTMLElement, evt): Promise<void> {
            try {
                const result = await fnAction.call(this, evt);

                if (item.closeOnAction === true && result !== false) {
                    hideCurrentModal(evt.currentTarget as HTMLElement | null);
                }
            } catch (err) {
                console.error('Error modal action:', err);
            }
        };
    }

    return function (evt): void {
        if (item.closeOnAction !== false) {
            hideCurrentModal(evt.currentTarget as HTMLElement | null);
        }
    };
}

// ----------------------------------------------------------------------------

export { hideCurrentModal, buildClickHandler };
